import { Component } from 'utils';
import { projectsActions } from '../../../store/reducers/projectsReducer';

@Component({
    controllerAs: 'vm',
    template: require('./environmentDetails.tpl.html')
})
export class EnvironmentDetailsComponent {
    static $inject = ['store', '$stateParams'];

    constructor(store, $stateParams) {
        this.store = store;
        this.projectId = $stateParams.id;
        this.envId = $stateParams.envID;

        this.unsubscribe = this.store.subscribe(() => {
            this.envDetail = this.store.getState().environments.envDetails;
        });

        this.$onDestroy = function () {
            this.unsubscribe();
        }

        this.store.dispatch({ type: 'GET_ENV_DETAILS', payload: { projectId: this.projectId, envId: this.envId } });
    }

    async $onInit() {
        const projectWithMetaData = this.store.getState().projects.projectWithMetaData;
        if (!projectWithMetaData) {
            const payload =  { projId: this.projectId };
            const response = await this.store.dispatch({ payload, type: projectsActions.GET_PROJECT_META_DATA });
            this.dbType = response.data.dbTypeId;
        } else {
            this.dbType = projectWithMetaData.dbTypeId;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/authorized/environmentDetails/environmentDetails.js